import Vue from 'vue';

Vue.component('loyalty-category-index', () =>
    import(/* webpackChunkName: 'loyalty-category-index' */ './loyalty-category-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/loyalty-category/index.js